import i18n from '../../i18n';

export const MESSAGES = {
  UPDATE_CONTENT: {
    ERROR: {
      401: i18n.t('You are not authorized to update the agent\'s content.'),
      403: i18n.t('You are not allowed to update the agent\'s content.'),
      404: i18n.t('The content you are trying to update does not exist.'),
      500: i18n.t('An error occurred updating the agent\'s content.'),
      default: i18n.t('An error occurred updating the agent\'s content.')
    },
    SUCCESS: {
      200: i18n.t('Agent content updated successfully.'),
      201: i18n.t('Agent content updated successfully.')
    }
  },
  UPDATE_MAIN_CHAPTERSOURCE: {
    ERROR: {
      401: i18n.t('You are not authorized to update the main flow.'),
      403: i18n.t('You are not allowed to update the main flow.'),
      404: i18n.t('The flow you are trying to update does not exist.'),
      500: i18n.t('An error occurred updating the main flow.'),
      default: i18n.t('An error occurred updating the main flow.')
    },
    SUCCESS: {
      200: i18n.t('Main flow updated successfully.')
    }
  }
};
